 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/Text/cover'
 import TEXT01_9781589805170_HT1 from '@/components/Text/01_9781589805170_HT1'
 import TEXT02_9781589805170_TITLE from '@/components/Text/02_9781589805170_Title'
 import TEXT03_9781589805170_COPYRIGHT from '@/components/Text/03_9781589805170_Copyright'
 import TEXT04_9781589805170_DEDICATION from '@/components/Text/04_9781589805170_Dedication'
 import TEXT05_9781589805170_TOC from '@/components/Text/05_9781589805170_TOC'
 import TEXT06_9781589805170_ACKNOW from '@/components/Text/06_9781589805170_Acknow'
 import TEXT07_9781589805170_INTRO from '@/components/Text/07_9781589805170_Intro'
 import TEXT08_9781589805170_HT2 from '@/components/Text/08_9781589805170_HT2'
 import TEXT09_9781589805170_CH01 from '@/components/Text/09_9781589805170_CH01'
 import TEXT10_9781589805170_CH02 from '@/components/Text/10_9781589805170_CH02'
 import TEXT11_9781589805170_CH03 from '@/components/Text/11_9781589805170_CH03'
 import TEXT12_9781589805170_CH04 from '@/components/Text/12_9781589805170_CH04'
 import TEXT13_9781589805170_CH05 from '@/components/Text/13_9781589805170_CH05'
 import TEXT14_9781589805170_CH06 from '@/components/Text/14_9781589805170_CH06'
 import TEXT15_9781589805170_APP_A from '@/components/Text/15_9781589805170_App_A'
 import TEXT16_9781589805170_APP_B from '@/components/Text/16_9781589805170_App_B'
 import TEXT17_9781589805170_APP_C from '@/components/Text/17_9781589805170_App_C'
 import TEXT18_9781589805170_APP_D from '@/components/Text/18_9781589805170_App_D'
 import TEXT19_9781589805170_APP_E from '@/components/Text/19_9781589805170_App_E'
 import TEXT20_9781589805170_APP_F from '@/components/Text/20_9781589805170_App_F'
 import TEXT21_9781589805170_APP_G from '@/components/Text/21_9781589805170_App_G'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/cover",
 			"name" : "Text/cover",
 			"component" : TEXTCOVER
 		},
 		{
 			"path" : "/Text/01_9781589805170_HT1",
 			"name" : "Text/01_9781589805170_HT1",
 			"component" : TEXT01_9781589805170_HT1
 		},
 		{
 			"path" : "/Text/02_9781589805170_Title",
 			"name" : "Text/02_9781589805170_Title",
 			"component" : TEXT02_9781589805170_TITLE
 		},
 		{
 			"path" : "/Text/03_9781589805170_Copyright",
 			"name" : "Text/03_9781589805170_Copyright",
 			"component" : TEXT03_9781589805170_COPYRIGHT
 		},
 		{
 			"path" : "/Text/04_9781589805170_Dedication",
 			"name" : "Text/04_9781589805170_Dedication",
 			"component" : TEXT04_9781589805170_DEDICATION
 		},
 		{
 			"path" : "/Text/05_9781589805170_TOC",
 			"name" : "Text/05_9781589805170_TOC",
 			"component" : TEXT05_9781589805170_TOC
 		},
 		{
 			"path" : "/Text/06_9781589805170_Acknow",
 			"name" : "Text/06_9781589805170_Acknow",
 			"component" : TEXT06_9781589805170_ACKNOW
 		},
 		{
 			"path" : "/Text/07_9781589805170_Intro",
 			"name" : "Text/07_9781589805170_Intro",
 			"component" : TEXT07_9781589805170_INTRO
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js